import React from "react";
import { env } from "../../../../config";
import { Dropdown } from "antd";
import {
  NotificationsIcon,
  NotificationsUnreadIcon,
} from "./NotificationsHelper";
import NotificationsDropdown from "./NotificationsDropdown";
import useNotifications from "../../../../components/AdminComponents/customHooks/useNotifications";

const NotifcationIcon = () => {
  const { notifications, notificationCount } = useNotifications();

  return (
    <>
      {(env === "dev" || env === "local") && (
        <Dropdown
          dropdownRender={() => (
            <NotificationsDropdown
              data={notifications}
              count={notificationCount}
            />
          )}
          placement="bottomLeft"
          arrow
        >
          <span style={{ marginTop: "3px" }}>
            {notificationCount > 0 ? (
              <NotificationsUnreadIcon color={"#255799"} dotColor={"#EC002A"} />
            ) : (
              <NotificationsIcon />
            )}
          </span>
        </Dropdown>
      )}
    </>
  );
};

export default NotifcationIcon;
